import Add from "@material-ui/icons/Add";
import ArrowBack from "@material-ui/icons/ArrowBack";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowForward from "@material-ui/icons/ArrowForward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Autorenew from "@material-ui/icons/Autorenew";
import Chat from "@material-ui/icons/Chat";
import ChatBubble from "@material-ui/icons/ChatBubble";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import Clear from "@material-ui/icons/Clear";
import Close from "@material-ui/icons/Close";
import ContentCopy from "@material-ui/icons/FileCopy";
import Description from "@material-ui/icons/Description";
import Done from "@material-ui/icons/Done";
import DragHandle from "@material-ui/icons/DragHandle";
import Edit from "@material-ui/icons/Edit";
import ExitToApp from "@material-ui/icons/ExitToApp";
import HeadsetMic from "@material-ui/icons/HeadsetMic";
import Info from "@material-ui/icons/Info";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import Person from "@material-ui/icons/Person";
import PersonAdd from "@material-ui/icons/PersonAdd";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import Reorder from "@material-ui/icons/Reorder";
import Search from "@material-ui/icons/Search";
import Settings from "@material-ui/icons/Settings";
import SubdirectoryArrowRight from "@material-ui/icons/SubdirectoryArrowRight";
import Today from "@material-ui/icons/Today";
import Home from "@material-ui/icons/Home";
import Save from "@material-ui/icons/Save";

export {
  Add,
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
  Autorenew,
  Chat,
  ChatBubble,
  ChevronRight,
  ChevronLeft,
  Clear,
  Close,
  ContentCopy,
  Description,
  Done,
  DragHandle,
  Edit,
  ExitToApp,
  HeadsetMic,
  Info,
  KeyboardArrowDown,
  KeyboardArrowRight,
  KeyboardArrowUp,
  Person,
  PersonAdd,
  PictureAsPdf,
  Reorder,
  Search,
  Settings,
  SubdirectoryArrowRight,
  Today,
  Home,
  Save
};
